/*
 * Public API Surface of ng9-odometer
 */

export * from './lib/ng9-odometer.component';
export * from './lib/ng9-odometer.module';
